import React, { useCallback, useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../components/Loader";
import {
  Backdrop,
  BackdropRoot,
  Button,
  createTheme,
  IconButton,
  InputAdornment,
  TextField,
  ThemeProvider,
} from "@mui/material";
import axios from "axios";
import sha512 from "crypto-js/sha512";
import { HistoryToggleOffRounded } from "@mui/icons-material";
import { Link, useHistory } from "react-router-dom";
// import fireLogo from "../../assets/images/firebird.png";
import fireLogo from "../../assets/images/logoMoov.jpg"
                   
import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { xCheckSumIdGernator } from "../../helper/helper";
import ConnectWithoutContactIcon from "@mui/icons-material/ConnectWithoutContact";
import KeyIcon from "@mui/icons-material/Key";
import Swal from "sweetalert2";
import {Tooltip } from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ContactEmergencyIcon from "@mui/icons-material/ContactEmergency";

export default function ForgotPasswordji() {
  const [open, setOpen] = useState(false);
  const [display, setDisplay] = useState("d-none");
  // const [timer, setTimer] = useState(60);
  const [disabled, setDisabled] = useState(false);
  const [timer, setTimer] = useState(0);
  const [contactus, setContactus] = useState({
    name: "",
    email: "",
    msisdn: "",
    subject: "",
    message: "",
  });
  const history = useHistory();
  const theme = createTheme({
    components: {
      MuiInputLabel: {
        styleOverrides: {
          asterisk: {
            color: "red",
          },
        },
      },
    },
  });

  const timeOutCallback = useCallback(
    () => setTimer((currTimer) => currTimer - 1),
    []
  );

  useEffect(() => {
    timer > 0 && setTimeout(timeOutCallback, 1000);
  }, [timer, timeOutCallback]);

  const resetTimer = function () {
    if (!timer) {
      setTimer(29);
    }
  };

  useEffect(() => {
    if (timer == 0) {
      setDisplay("d-none");
    } else {
      setDisplay("");
    }
  }, [timer]);

  // const timeOutCallback = useCallback(
  //   () => setTimer((currTimer) => currTimer - 1),
  //   []
  // );
  // useEffect(() => {
  //   timer > 0 && setTimeout(timeOutCallback, 1000);
  // }, [timer, timeOutCallback]);

  // const resetTimer = function () {
  //   if (!timer) {
  //     setTimer(59);
  //   }
  // };


  const validationSchema = yup.object({
    // email: yup

    //   .string()
    //   .email("E-Mail must be valid")
    //   .max(255)
    //   .required("E-Mail  is required"),
    // .required("Username is required"),
    msisdn: yup
      .number("Enter Your Number Here")
      // .email("E-Mail must be valid")

      // .min(1000000000, "Number should be of minimum 10 characters length")
      // .max(1000000000000, "Number should be of maximum 12 characters length"),
      .min(10000000, "Minimum length of a mobile number is 8 digits")
      .max(100000000, "Maximum length of mobile number is 8 digits")
  });
  const formik = useFormik({
    initialValues: {
      email: "",
    },

    onReset: (initialValues) => ({
      values: { initialValues },
    }),
    validateOnChange: true,

    validationSchema: validationSchema,

    onSubmit: async (values) => {
      try {
        const xCheckSumValues = xCheckSumIdGernator(values.msisdn);

        // const generator = Math.floor(Math.random() * 100000000);
        // const allValues = `${values.msisdn}${generator}54IzSRi`;
        // const allValuesHashed = sha512(allValues).toString();
        setOpen(true);
        // const res = await axios.post(
        //   `${process.env.REACT_APP_COMMON_API}/auth/v1/forget/password/`,
        //   {
        //     email: values.email,
        //     requestId: generator,
        //     isDebug: false,
        //   },
        //   {
        //     headers: {
        //       "X-CHECKSUM-ID": allValuesHashed,
        //     },
        //   }
        // );
        const res = await axios.post(
          `${process.env.REACT_APP_COMMON_API}/auth/v1/pin/generate`,
          {
            msisdn: "222" + values.msisdn,
            requestId: xCheckSumValues.generator,
            isDebug: true,
          },
          {
            headers: {
              "X-CHECKSUM-ID": xCheckSumValues.allValuesHashed,
            },
          }
        );

        if (res.data.statusDescription.statusCode == 200) {
          setOpen(false);

          localStorage.setItem("transaction", res.data.transactionId);
          localStorage.setItem("values", values.msisdn);

          await setTimeout(async () => {
            // await setDisabled(true);
            // await toast.success(
            //   "We have Sent a Verification Code !Please Check Your Messages!!",
            //   {
            //     theme: "colored",
            //   }
            // );
            Swal.fire({
              icon: "success",
              // title: "Oops...",
              text:"We have Sent a Verification Code !Please Check Your Messages!!s",
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
          await history.replace("/VerifyOtp");
          await setDisplay();
        } else {
          setOpen(false);
          await setTimeout(async () => {
            // await toast.error(res.data.statusDescription.description, {
            //   theme: "colored",
            // });
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text:res.data.statusDescription.description,
              // footer: '<a href="">Why do I have this issue?</a>'
            });
          }, 100);
          await setDisplay();
        }
      } catch (error) {
        setOpen(false);

        await setTimeout(async () => {
          // await toast.error(
          //   "Something went wrong!! PLease check your network",
          //   {
          //     theme: "colored",
          //   }
          // );
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text:"Something Went Wrong ! Please check your network",
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }, 100);
      }
    },
  });



// ..........................................Contact Us...................................................................//
const modalContact = useRef(null);
const modalContactClose = useRef(null);

const contactModal = async () => {
  await modalContact.current.click();
};

const contactUs = async (e) => {
  e.preventDefault();
  try {
    setOpen(true);
    const generator = Math.floor(Math.random() * 100000000);
    const allValues = `${contactus.msisdn}${generator}54IzSRi`;
    const allValuesHashed = sha512(allValues).toString();
    // console.log({ allValues, generator });
    // console.log({ allValuesHashed });

    const res = await axios.post(
      `${process.env.REACT_APP_COMMON_API}/admin/v1/lead/generation/add`,
      {
        name: contactus.name,
        email: contactus.email,
        msisdn:"222" + contactus.msisdn,
        subject: contactus.subject,
        message: contactus.message,
        requestId: generator,
        isDebug: true,
      },
      {
        headers: {
          "X-CHECKSUM-ID": allValuesHashed,
        },
      }
    );

    if (res.data.statusDescription.statusCode == 200) {
      setOpen(false);
      await modalContactClose?.current?.click();
      await setTimeout(() => {
        // toast.success("Your query has been Submitted !!", {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "success",
          // title: "Oops...",
          text:"Your query has been Submitted !!",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }, 100);
    } else {
      setOpen(false);
      await modalContactClose?.current?.click();
      await setTimeout(() => {
        // toast.error(res.data.statusDescription.description, {
        //   theme: "colored",
        // });
        Swal.fire({
          icon: "error",
           title: "Oops...",
          text:res.data.statusDescription.description,
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }, 100);
    }
  } catch (error) {
    setOpen(false);
    await modalContactClose?.current?.click();
    // console.log(error);

    // await toast.error("Something Went Wrong ! Please check your network", {
    //   theme: "colored",
    //   customId1,
    // });
    Swal.fire({
      icon: "error",
       title: "Oops...",
      text: "Something Went Wrong ! Please check your network",
      // footer: '<a href="">Why do I have this issue?</a>'
    });
  }
};











  return (
    <>
      
        <Backdrop
          sx={{
            transform: "translateZ(0)",
            color: "#fff",
            zIndex: (theme) => theme.zIndex.drawer + 1,
          }}
          open={open}
          // onClick={handleClose}
        >
          <Loader />
        </Backdrop>

         <button
            ref={modalContact}
            type="button"
            class="btn btn-primary"
            data-bs-toggle="modal"
            className="btn btn-primary d-none"
            data-bs-target="#exampleModal"
            // data-bs-whatever="@mdo"
          >
            Open modal for contact
          </button>

          <div
            class="modal fade"
            id="exampleModal"
            tabindex="-1"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div class="modal-dialog">
              <div class="modal-content">
                <form onSubmit={contactUs}>
                  <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">
                      Contact Us
                    </h1>
                    <button
                      type="reset"
                      class="btn-close"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      ref={modalContactClose}
                    ></button>
                  </div>
                  <div class="modal-body">
                    <div className="row">
                      <div class="col-md-6">
                        <label for="recipient-name" class="col-form-label">
                          Name:
                        </label>
                        <input
                          min={3}
                          required
                          type="text"
                          class="form-control form_Control"
                          id="recipient-name"
                          onChange={(e) => {
                            setContactus({
                              ...contactus,
                              name: e.target.value,
                            });
                          }}
                        />
                      </div>
                      <div class="col-md-6 ">
                        <label for="recipient-name" class="col-form-label">
                          E-mail:
                        </label>
                        <input
                          required
                          type="email"
                          class="form-control form_Control"
                          id="email-name"
                          onChange={(e) => {
                            setContactus({
                              ...contactus,
                              email: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div className="row my-3">
                    <div class=" col-md-6 mb-2">
                        <label for="recipient-name" class="col-form-label">
                          Phone-Number:
                        </label>
                        <div className="d-flex">
                       <div className="w-25">

                        <input className="inpt_Width w-100" disabled value="+222" />
                       </div>
                        <input
                          required
                          type="number"
                          maxLength={8}
                          class="form-control form_Control form_Control_radius w-100"
                          id="phone-number-name"
                          onChange={(e) => {
                            setContactus({
                              ...contactus,
                              msisdn: e.target.value,
                            });
                          }}
                          onInput={(e) => {
                          e.target.value = Math.max(0, parseInt(e.target.value))
                            .toString()
                            .slice(0, 8);
                        }}
                        />
                        </div>
                      </div>
                      <div class=" col-md-6 mb-2">
                        <label for="recipient-name" class="col-form-label">
                          Subject:
                        </label>
                        <input
                          required
                          type="text"
                          class="form-control form_Control"
                          id="subject-name"
                          onChange={(e) => {
                            setContactus({
                              ...contactus,
                              subject: e.target.value,
                            });
                          }}
                        />
                      </div>
                    </div>
                    <div class="mb-2">
                      <label for="message-text" class="col-form-label">
                        Message:
                      </label>
                      <textarea
                        required
                        rows={6}
                        class="form-control form_Control"
                        id="message-text"
                        onChange={(e) => {
                          setContactus({
                            ...contactus,
                            message: e.target.value,
                          });
                        }}
                      ></textarea>
                    </div>
                  </div>
                  <div className="modal-footer justify-content-between align-items-center">
                    <button
                      type="reset"
                      class="btn btn-secondary"
                      data-bs-dismiss="modal"
                      // onClick={() => {
                      //   form.reset
                      // }}
                    >
                      Close
                    </button>
                    <button type="submit" class="btn btn-primary">
                      Send message
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div> 

          <main className="main-content position-relative max-height-vh-100 h-100 border-radius-lg ">
        <ToastContainer autoClose={4000} />
        <ThemeProvider theme={theme}>
          <div class="container-fluid px-0">
            <div class="row d-md-flex d-none h_vh align-items-cente mx-0">
              <div class="col-md-7 bg_18 d-flex">
                <div class="ps_8 my-auto py_5">
                  <img src={fireLogo} class="img-fluid d-block mx-auto" />
                  <p class="text-center m-0 my-4 fw-bold">
                  Moov Mauritel, An Omni Channel Solution which broadens
                    Communication channels to Telecom operators. Its an
                    integrated platform to meet the Business requirements with
                    respect to Messaging solutions and Voice solutions.
                  </p>
                  {/* <div
                    class="d-flex justify-content-center align-items-center fw-bold"
                    style={{ color: "#000" }}
                  >
                    <p style={{ fontWeight: "bold" }}>Want to contact us ? </p>
                    <Link to="/contactus">
                      <Button variant="contained">Contact US --> </Button>
                    </Link>
                  </div> */}
                  <div
                      class="d-flex justify-content-center align-items-center fw-bold"
                      style={{ color: "#000" }}
                    >
                      {/* <Link to="/contactus"> */}
                      <Button
                        variant="contained"
                        endIcon={<ContactEmergencyIcon />}
                        onClick={() => {
                          contactModal();
                        }}
                      >
                        Contact US
                      </Button>
                      {/* </Link> */}
                      {/* <ConnectWithoutContactIcon
                          style={{ cursor: "pointer", fontSize: "28px" }}
                          className="d-block ms-3"
                        /> */}
                    </div>
                </div>
              </div>
              <div
                class="col-md-5 d-flex align-items-center bg_8 p-4"
                style={{ padding: "3.5rem" }}
              >
                <div class="w-100">
                  <form onSubmit={formik.handleSubmit}>
                    <div class="" id="sign_in">
                      <div class="">
                        <div class="text-center">
                          <KeyIcon
                            style={{
                              fontSize: "25px",

                              color: "white",
                              border: "0.5px solid #0083AD",
                              borderRadius: "30px",
                              backgroundColor: "#0083AD",
                            }}
                          />
                        </div>
                        <div class="text-center mt-2">
                          <span class="d-inline-block text-capitalize">
                            Forgot Password
                          </span>
                        </div>
                      </div>
                      <div class="my-4">
                        <div class="input-group input-group-outline input_field">


                        <div className="col-md-12 d-flex" id="inp_merge">
                        <div className="me-2 my-auto">
                              <LocalPhoneIcon style={{ fontSize: "17px" }} />
                            </div>
                    <div className="d-flex w-100">
                      <input className="inpt_width" disabled value="+222" />
                      <TextField
                        className="m-0 w-100" 
                        style={{
                          borderRadius: "4px",
                        }}
                        type="number"
                        label="Your Number Here"
                        name="msisdn"
                        variant="outlined"
                        // value={number}
                        size="small"
                        required
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <Tooltip
                                title="Mobile Number"
                                placement="top"
                                arrow
                                sx={{ color: "#85CBF2" }}
                              >
                                <InfoIcon />
                              </Tooltip>
                            </InputAdornment>
                          ),
                        }}
                        value={formik.values.msisdn}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.msisdn &&
                                Boolean(formik.errors.msisdn)
                              }
                              helperText={
                                formik.touched.msisdn && formik.errors.msisdn
                              }
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 8);
                              }}
                      />
                    </div>
                  </div>

                           {/* <div className="col-md-12 d-inline-flex">
                            <div className="me-2 mt-3">
                              <LocalPhoneIcon style={{ fontSize: "17px" }} />
                            </div>
                            <TextField
                              required
                              className="w-100"
                              label="Your Number Here"
                              name="msisdn"
                              type="number"
                              variant="standard"
                              size="small"
                              value={formik.values.msisdn}
                              onChange={formik.handleChange}
                              error={
                                formik.touched.msisdn &&
                                Boolean(formik.errors.msisdn)
                              }
                              helperText={
                                formik.touched.msisdn && formik.errors.msisdn
                              }
                              onInput={(e) => {
                                e.target.value = Math.max(
                                  0,
                                  parseInt(e.target.value)
                                )
                                  .toString()
                                  .slice(0, 8);
                              }}
                            />
                          </div>  */}
                        </div>
                      </div>
                      <button
                        type="submit"
                        class="btn bg-gradient-primary register_grad d-block w-100 m-0"
                        // disabled={timer != 0}
                      >
                        Send
                        {/* <span className={`${display}`}>
                          {" "}
                          in:{timer} seconds
                        </span> */}
                      </button>
                      <div className="row my-3">
                        <div className="col-md-6">
                          <div className="text-start fw-bold">
                            <a
                              href="#"
                              onClick={formik.handleReset}
                              class="text-capitalize link-info"
                            >
                              Reset
                            </a>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            class="text-end  fw-bold link-info"
                            id="sign_up_in"
                          >
                            <Link
                              to="/"
                              class="text-capitalize"
                              onClick={() => {
                                localStorage.clear();
                              }}
                            >
                              Log In
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </ThemeProvider>
      </main>
    </>
  );
}
